import { render } from "./ResultsPopup.vue?vue&type=template&id=aa780aa8&scoped=true"
import script from "./ResultsPopup.vue?vue&type=script&lang=js"
export * from "./ResultsPopup.vue?vue&type=script&lang=js"

import "./ResultsPopup.vue?vue&type=style&index=0&id=aa780aa8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa780aa8"]])

export default __exports__